import { CassetteChock } from "@/pages/catalogs/models/CassetteChock";
import { ErrorModal, getMomentTz } from "@dexteel/mesf-core";
import { Grid2 } from "@mui/material";
import { DateTimeField } from "@mui/x-date-pickers";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getCassetteChocks } from "../../repositories/parts/CassetteChockRepository";

const moment = getMomentTz();

type useCassetteChocksProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: CassetteChock[]) => void;
};

export const useCassetteChocks = ({
	partId,
	onError,
	onSuccess,
}: useCassetteChocksProps) => {
	return useQuery<CassetteChock[], Error>({
		queryKey: ["cassetteChocks", partId],
		queryFn: ({ signal }) => getCassetteChocks({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificCassetteChockData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [chock, setCassetteChock] = useState<CassetteChock>();

	const { data: cassetteChocks } = useCassetteChocks({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: CassetteChock[]) => {
			setCassetteChock(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<DateTimeField
						value={
							chock?.RebuildTimestamp
								? moment.utc(chock.RebuildTimestamp)
								: null
						}
						label="Rebuild Date"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<DateTimeField
						value={
							chock?.BearingChangeTimestamp
								? moment.utc(chock.BearingChangeTimestamp)
								: null
						}
						label="Bearing Change Date"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
